//components
import { Row, Col } from "antd";
import { useSelector } from "react-redux";
import placeholder from "../../../../../asset/img/placeholder.png";
import { branchDetailBySlugSelector } from "../../../../../store/branch/branch.selector";
import branchGettimelyImg from "../../../../../asset/img/other-nail-booking.png";
import bookNow from "../../../../../asset/img/book.png";
//actions
//selector
//function
//str

const BranchGettimely = ({ mobile, tablet }) => {
  // -------------------------- VAR --------------------------
  const paddingValue = mobile ? "20px 10px" : "50px 20px";
  const btnWidth = mobile ? "100%" : "90%";
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const branchDetail = useSelector(branchDetailBySlugSelector);
  // -------------------------- FUNCTION --------------------------
  const handleClick = () => {
    // window.location.href = branchDetail?.branchGettimelyLink;
    window.open(branchDetail?.branchGettimelyLink, "_blank");
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <div style={{ width: "100%", maxWidth: 400, margin: "0 auto", padding: 0 }}>
      {/* card container with rounded corners and overflow hidden */}
      <div
        style={{
          border: "10px solid #4A2C04",
          borderRadius: 20,
          overflow: "hidden",
          backgroundColor: "#eadbcc",
        }}
      >
        <img
          src={branchGettimelyImg || placeholder}
          alt="Book Now"
          style={{ width: "100%", display: "block" }}
        />

        <div
          style={{
            padding: paddingValue,
          }}
        >
          <Row gutter={[12, 0]}>
            <Col
              span={6}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            ></Col>
            <Col
              span={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={bookNow || placeholder}
                alt="Book Now"
                style={{ width: btnWidth, display: "block" }}
                onClick={handleClick}
              />
            </Col>
            <Col
              span={5}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            ></Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
export default BranchGettimely;
